<template>
  <div class="py-2 w-full">
    <textarea
      name="input"
      :rows="rows"
      class="w-full px-4 text-sm md:text-base border-1 border-brand-mid-gray shadow-sm rounded resize-none placeholder-brand-mid-gray text-brand-black focus:border-brand-green focus:ring-brand-green"
      :placeholder="placeholder"
      :class="{ 'bg-brand-light-gray': entered }"
      :value="value"
      @blur="checkEntered"
      :required="required"
      ref="input"
      :disabled="disabled"
      data-private
    />
  </div>
</template>
<script>
export default {
  props: {
    placeholder: {
      type: String
    },
    value: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 4
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.entered = !!this.value
  },
  data() {
    return {
      entered: false
    }
  },
  methods: {
    checkEntered() {
      this.entered = !!this.value
      this.$emit("blur")
    }
  }
}
</script>
<style lang="scss"></style>
